class RelatedProductVariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.onSwatchClick.bind(this));
  }

  onSwatchClick(event) {
    // Find the closest swatch link, but don't do anything if it's already active.
    event.preventDefault();
    const swatchLink = event.target.closest('.swatch__button');
    if (!swatchLink) {
      return;
    }

    if (swatchLink.classList.contains('active')) {
      console.log('RelatedProductVariantPicker: Clicked swatch is already active. Aborting.');
      return;
    }

    // Update active state visually
    this.querySelectorAll('.swatch-item.active').forEach((activeSwatch) => activeSwatch.classList.remove('active'));
    swatchLink.classList.add('active');

    const productUrl = swatchLink.dataset.handle; // Use pathname to get /products/handle

    // Render new contents
    this.renderSections(productUrl);
  }

  getSectionsToRender() {
    // Defines the primary section to update first.
    const sections = [
      {
        sectionId: this.closest("[data-section-type='product']")?.dataset.sectionId,
        selector: "data-section-type='product'"
      },
      {
        sectionId: "api-product-upsell",
        selector: "data-section-type='api-product-upsell'"
      }
    ];
    console.log('RelatedProductVariantPicker: getSectionsToRender found:', sections);
    return sections;
  }

  getBelowFoldSectionsToRender() {
    // Defines all the secondary sections to update after the primary one.
    return [
      {
        selector: 'js-product-object-image-text-main-new',
        sectionId: document.querySelector('[js-product-object-image-text-main-new]')?.dataset.section,
      },
      {
        selector: 'js-index-object-banner-texts-main-new',
        sectionId: document.querySelector('[js-index-object-banner-texts-main-new]')?.dataset.section,
      },
      {
        selector: 'js-product-object-full-looks-main-new',
        sectionId: document.querySelector('[js-product-object-full-looks-main-new]')?.dataset.section,
      },
      {
        selector: 'js-index-object-tabs-columns-main-new',
        sectionId: document.querySelector('[js-index-object-tabs-columns-main-new]')?.dataset.section,
      },
    ];

  }

  renderSections(productUrl) {
    const self = this;

    this.getSectionsToRender().forEach((section) => {
      let url = `${location.origin}${productUrl}?section_id=${section.sectionId}`;

      if (section.sectionId != undefined) {
        console.log(`RelatedProductVariantPicker: Fetching main section [${section.selector}] from URL: ${url}`);
        fetch(url)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const elementToReplace = document.querySelector(`[${section.selector}]`);

            if (!elementToReplace) return

            const sectionType = elementToReplace.dataset.sectionType;


            if (elementToReplace && doc.querySelector(`[${section.selector}]`)) {
              // Unload existing scripts to prevent memory leaks and duplicate event listeners
              if (sectionType && window.Shopify.theme.sections.isInstance(elementToReplace)) {
                window.Shopify.theme.sections.unload(elementToReplace);
              }

              // Replace the section's inner HTML with the new content
              elementToReplace.innerHTML = doc.querySelector(`[${section.selector}]`).innerHTML;

              if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
                window.yotpoWidgetsContainer.initWidgets();
              }


              document.dispatchEvent(new CustomEvent('theme:product:variantChanged', {
                detail: {
                  container: elementToReplace,
                  productUrl: productUrl
                }
              }));


              // Re-initialize scripts for the new content
              if (sectionType) {

                window.Shopify.theme.sections.load(sectionType, elementToReplace);
              }
            } else {

            }

            if (window.location.pathname.includes('/products/')) {

              self.updateHistoryState(productUrl);
            }

            // Now render the below-the-fold sections

            this.renderBelowFoldSections(productUrl);
          })
          .catch(function (error) {
            console.error('Error rendering main section:', error);
            // window.location = productUrl; // Fallback to full page load
          });
      } else {
        console.warn(`RelatedProductVariantPicker: sectionId for [${section.selector}] is undefined. Skipping fetch.`);
      }
    });
  }

  renderBelowFoldSections(productUrl) {

    this.getBelowFoldSectionsToRender().forEach((section) => {
      if (section.sectionId != undefined) {
        let url = `${location.origin}${productUrl}?section_id=${section.sectionId}`;
        if (document.querySelector('[js-quickatc-popup-wrapper]')?.dataset.bundleProduct == 'true') {
          url = `${location.origin}${productUrl}?view=bundle&section_id=${section.sectionId}`;
        }

        console.log(`RelatedProductVariantPicker: Fetching below-fold section [${section.selector}] from URL: ${url}`);
        fetch(url)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const elementToReplace = document.querySelector(`[${section.selector}]`);

            if (elementToReplace && doc.querySelector(`[${section.selector}]`)) {
              console.log(`RelatedProductVariantPicker: Replacing content for below-fold [${section.selector}]`);
              elementToReplace.innerHTML = doc.querySelector(`[${section.selector}]`).innerHTML;
            }

            // Dispatch events for specific below-fold sections
            switch (section.selector) {
              case 'js-product-object-image-text-main-new':
                document.dispatchEvent(new CustomEvent('product-object-image-text-sliders:init'));
                break;
              case 'js-product-object-full-looks-main-new':
                document.dispatchEvent(new CustomEvent('product-object-full-looks-items-slider:init'));
                break;
              case 'js-index-object-tabs-columns-main-new':
                document.dispatchEvent(new CustomEvent('indexObjectTabsColumnsSlider:init'));
                document.dispatchEvent(new CustomEvent('tabsCommonScript:init'));
                break;
            }
          })
          .catch(function (error) {
            console.error(`Error rendering below-fold section ${section.selector}:`, error);
          });
      } else {
        console.warn(
          `RelatedProductVariantPicker: sectionId for below-fold [${section.selector}] is undefined. Skipping fetch.`
        );
      }
    });
  }

  updateHistoryState(productUrl) {
    const newurl = `${window.location.origin}${productUrl}`;
    window.history.replaceState({ path: newurl }, '', newurl);
  }
}

// Register the custom element
customElements.define('related-product-variant-picker', RelatedProductVariantPicker);

